<template>
  <section>
    <button
      class="button is-primary is-medium"
      @click="isComponentModalActive = true"
    >
      Hide notes
    </button>

    <b-modal :active.sync="isComponentModalActive" full-screen class="curtain">
      <section class="hero is-primary is-fullheight">
        <div class="hero-body">
          <div class="container">
            <img src="../assets/logo-knockout.png" alt="clujr" />
            <h1 class="title">
              No peeking!
            </h1>
          </div>
        </div>
      </section>
    </b-modal>
  </section>
</template>

<script>
export default {
  data() {
    return {
      isComponentModalActive: false,
    };
  },
};
</script>
